import React from "react";
import {
  Bookmark,
  EyeOff,
  Flag,
  X,
} from "lucide-react";
import "./FeedMenuPopup.css";

function FeedMenuPopup({
  post,
  onReport,
  onHide,
  onSave,
  close,
  menuRef,
  isSaved = false,
}) {
  return (
    <div
      className="feed-menu-popup"
      ref={menuRef}
      onClick={(e) => e.stopPropagation()}
    >
      {/* SAVE */}
      <button onClick={() => onSave(post._id)}>
        <Bookmark
          size={17}
          strokeWidth={2}
          fill={isSaved ? "currentColor" : "none"}
        />

        <span>
          {isSaved ? "Unsave Post" : "Save Post"}
        </span>
      </button>

      {/* HIDE */}
      <button onClick={() => onHide(post)}>
        <EyeOff size={17} strokeWidth={2} />
        <span>Hide</span>
      </button>

      {/* REPORT */}
      <button onClick={() => onReport(post)}>
        <Flag size={17} strokeWidth={2} />
        <span>Report</span>
      </button>

      {/* CLOSE */}
      <button
        className="btn-outline"
        onClick={close}
      >
        <X size={17} strokeWidth={2} />
        <span>Close</span>
      </button>
    </div>
  );
}

export default FeedMenuPopup;
